/**
 * @module SaveGisControl
 */
import "./SaveGisControl.css";
import Control from 'ol/control/Control';
import { t } from '../utils/i18n';

class SaveGisControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    // Remove the query string from the filename if it has one
    if (options.filename && options.filename.includes('?')) {
      options.filename = options.filename.split('?')[0];
    }

    // Create the container div
    const container = document.createElement('div');
    container.className = 'nhc-map-save-png-button border-top border-gray-10 padding-y-1 padding-x-2';

    container.innerHTML = `
      <button id="export-${options.id}-gis" class="usa-button" type="button">
        ${t("control_save_gis_label")}
      </button>
      <a id="${options.id}-gis-download" class="usa-sr-only" data-filename="${options.filename}"></a>
      <p id="${options.id}-gis-filename" class="gis-filename">
        (${options.filename.split('/').pop()})
      </p>
    `;

    super({
      element: container,
      target: options.target
    });

    this.id = options.id;

    // Bind event handler for the save PNG button
    const gisButton = container.querySelector(`#export-${options.id}-gis`);
    gisButton.addEventListener('click', () => {
      const saveFile = this.getFilename();
      this.saveGIS(saveFile);
    });

  }

  /**
   * Updates the language-specific elements.
   */
  updateLanguage() {
    const gisButton = document.getElementById(`export-${this.id}-gis`);
    if (gisButton) {
      this.label = t("control_save_gis_label");
      gisButton.textContent = this.label;
    }
  }

  /**
   * Gets the saveFile filename from the data-filename attribute. We use this
   * attribute so that the filename can be set dynamically. E.g. in the
   * rip current graphic, there are day1 and day2 versions and the control that
   * toggles between them can change this setting.
   * @returns {string} The filename to save the PNG as
   */
  getFilename() {
    const filenameElement = document.getElementById(`${this.id}-gis-download`);
    const saveFile = filenameElement.getAttribute('data-filename');
    // Remove any query string from the filename
    const queryIndex = saveFile.indexOf('?');
    if (queryIndex !== -1) {
      return saveFile.substring(0, queryIndex);
    }
    // If no query string, return the filename as is
    return saveFile;
  }

  /**
   * Captures the content of the webpage as a PNG image while ignoring certain
   * elements (e.g., zoom and full-screen controls). It creates a downloadable 
   * link, sets it to the PNG data, and triggers a download so the user can 
   * save the image as map.png.
   * @param {string} date 
   */
  saveGIS(saveFile) {
    const gisDownload = document.getElementById(`${this.id}-gis-download`);
    gisDownload.href = saveFile;
    gisDownload.setAttribute('download', saveFile.split('/').pop() || 'rip_currents_day1_latest.geojson');
    gisDownload.click();
  }

}

export default SaveGisControl;